import * as React from "react";
import useTable from "../../useTable";
import { VariableSizeGrid } from "react-window";

import Header from "../Header";
import Cell from "../Cell";
import { Base, ResizeListener, ShadowUnder } from "./styles";

import { ROW_HEIGHT } from "../constants";

import useSizing from "./useSizing";
import useScroll from "./useScroll";

type Props = {
  style?: React.CSSProperties;
};
function Table({ style }: Props) {
  const [showShadow, setShowShadow] = React.useState(false);

  const {
    columnWidths,
    dimensions,
    amountOfColumns,
    gridRef,
    resizeRef
  } = useSizing(style);
  const { headerRef, outerGridRef } = useScroll();

  const { data, isLoading } = useTable();

  return (
    <Base style={style}>
      <ResizeListener
        ref={resizeRef}
        aria-hidden={true}
        aria-label="resize-listener"
        tabIndex={-1}
      />

      {dimensions && (
        <>
          <Header
            ref={headerRef}
            columnWidths={columnWidths}
            showShadow={showShadow}
          />
          <VariableSizeGrid
            ref={gridRef}
            outerRef={outerGridRef}
            onScroll={({ scrollTop }) => {
              if (scrollTop === 0) {
                setShowShadow(false);
              } else if (!showShadow && scrollTop > 0) {
                setShowShadow(true);
              }
            }}
            columnWidth={index => {
              return columnWidths[index];
            }}
            columnCount={amountOfColumns}
            rowCount={isLoading ? 30 : data.length}
            rowHeight={() => ROW_HEIGHT}
            width={dimensions.width}
            height={dimensions.height - ROW_HEIGHT} // subtract header-row
            itemData={data}
          >
            {Cell}
          </VariableSizeGrid>
          {data.length * ROW_HEIGHT > dimensions!.height - ROW_HEIGHT && (
            <ShadowUnder
              style={{
                width: dimensions.width
              }}
            />
          )}
        </>
      )}
    </Base>
  );
}

export default React.memo(Table);
